<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <Header />
  
      <b-card class="bCardGlobal">
        <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span
              ><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon
            ></span>
            <span>LISTA DE ESPERA</span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>Código</div>
          </b-col>
        </b-row>
  
        <div class="divSubtitulo">
          <p class="textSubtitulo">Configuración de semaforo lista de espera</p>
        </div>
  
        <b-row>
          <b-col>
            <b-row align-v="center" align-h="end">
              <b-col>
                
              </b-col>
  
              <b-col></b-col>
  
              <b-col align="right">
                <b-button
                  v-b-tooltip.hover
                  title="Agregar nuevo estatus"
                  variant="outline-primary"
                  @click="abrirModal()"
                  >Agregar estatus
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
  
        <!--   Tabla   -->
  
        <b-row>
          <b-col cols="12">
            <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos mt-4"
              fixed
            >
              <template v-slot:cell(slaMinimo)="row">
                {{ row.item.slaMinimo }}
              </template>
              <template v-slot:cell(slaMaximo)="row">
                {{ row.item.slaMaximo }} 
              </template>
              <template v-slot:cell(proximaCita)="row">
                {{
                  row.item.proximaCita != null && row.item.proximaCita != false
                    ? "Sí"
                    : "No"
                }}
              </template>
              <template v-slot:cell(codigoColor)="row">
                <b-icon
                  icon="circle-fill"
                  aria-hidden="true"
                  font-scale="2"
                  :style="{ color: row.item.codigocolor }"
                ></b-icon>
              </template>
              <template v-slot:cell(registroActivo)="row">
                {{ row.item.registroActivo ? "Activo" : "Inactivo" }}
              </template>
              <template v-slot:cell(Acciones)="row">
                <b-button-group>
                  <b-button
                    title="Modificar Tipo de Solicitud"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                    ><em class="fa fa-pencil"></em
                  ></b-button>
                  <b-button
                    v-if="!row.item.registroActivo"
                    title="Activar tipo solicitud"
                    variant="outline-success"
                    size="sm"
                    @click="activarDesactivarEstatus(row.item)"
                    ><em class="fa fa-undo"></em
                  ></b-button>
                  <b-button
                    v-else
                    title="Desactivar tipo solicitud"
                    variant="outline-danger"
                    size="sm"
                    @click="activarDesactivarEstatus(row.item)"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </b-button-group>
              </template>
            </b-table>
            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert v-if="datosTabla.length === 0" variant="warning" show
                >No hay datos</b-alert
              >
            </b-col>
            <b-col v-if="!loader">
              <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
              ></b-pagination>
            </b-col>
          </b-col>
        </b-row>
      </b-card>
  
   
      <!--  Modal  -->
      <b-modal
        v-model="modalAgregarEstatus"
        :title="tituloModal "
        size="lg"
        scrollable
      >
        <b-form @submit.stop.prevent="verificarEstatus">
          <b-container fluid>
            
            <b-row>
              <b-col>
                <b-form-group
                  align="left"
                  label-align="left"
                  class="mginInputTrt"
                  id="fieldset-1"
                >
                
  
                  <label>Nombre del estatus</label>
                  <b-form-input
                    v-model="datosGuardar.nombreEstatus"
                    type="text"
                    :state="datosGuardar.nombreEstatus != '' && datosGuardar.nombreEstatus != null"
                  ></b-form-input>
                </b-form-group>
                <b-form-invalid-feedback :state="datosGuardar.nombreEstatus != '' && datosGuardar.nombreEstatus != null">
                    El campo "Nombre del estatus" es obligatorio
                  </b-form-invalid-feedback>
                <div class="row">
                  <div class="col-6">
                    <b-form-group align="left">
                      <label
                        >SLA inicial (en días):
                        <validacion />
                      </label>
                      <b-input-group size="sm" class="mb-2" id="nombre">
                        <b-input-group-prepend is-text>
                          <b-icon icon="calendar4-week"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          name="nombre"
                          placeholder="SLA"
                          type="number"
                          v-model="datosGuardar.slaMinimo"
                          :state=" datosGuardar.slaMinimo != '' && datosGuardar.slaMinimo != null"
                          
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                     <b-form-invalid-feedback :state="datosGuardar.slaMinimo != '' && datosGuardar.slaMinimo != null">
                    Este campo es obligatorio
                  </b-form-invalid-feedback>
                  
                  </div>
                  <div class="col-6">
                    <b-form-group align="left">
                      <label
                        >SLA final (en días):
                        <validacion />
                      </label>
                      <b-input-group size="sm" class="mb-2" id="nombre">
                        <b-input-group-prepend is-text>
                          <b-icon icon="calendar4-week"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input
                          name="nombre"
                          placeholder="SLA"
                          type="number"
                          :min="datosGuardar.slaMinimo"
                          v-model="datosGuardar.slaMaximo"
                          :state=" datosGuardar.slaMaximo != '' && datosGuardar.slaMaximo != null"
                          @keydown="slaKeydown($event)" 
                        ></b-form-input>
                      </b-input-group>
                    </b-form-group>
                       <b-form-invalid-feedback :state=" datosGuardar.slaMaximo != '' && datosGuardar.slaMaximo != null">
                    Este campo es obligatorio
                  </b-form-invalid-feedback>
                  </div>
                </div>
  
                <b-form-group align="left">
                  <label
                    >Color
                    <validacion />
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="brush"></b-icon>
                    </b-input-group-prepend>
                    <v-select
                      id="nombreMenu"
                      name="nombreMenu"
                      placeholder="Color del semaforo"
                      v-model="datosGuardar.idColor"
                      label="nombre"
                      style="width: 95%"
                      :reduce="(variable) => variable.idColor"
                      :options="colores"
                      :state="datosGuardar.idColor != ''"
                    >
                      <template v-slot:option="option">
                        <em
                          class="fa fa-circle"
                          :style="{ color: option.codigo }"
                        >
                        </em>
                        {{ option.nombre }}
                      </template>
                    </v-select>
                  </b-input-group>
                </b-form-group>
                       <b-form-invalid-feedback :state="datosGuardar.idColor != ''">
                    Este campo es obligatorio y debe de ser mayor al SLA mínimo
                  </b-form-invalid-feedback>
  
                
              </b-col>
            </b-row>
          </b-container>
          <b-button
            ref="submitGuardar"
            type="submit"
            style="visibility: hidden"
          ></b-button>
        </b-form>
  
        <template v-slot:modal-footer>
          <b-button
            variant="outline-primary"
            @click="verificarEstatus()"
            :disabled="loaderAcciones"
          >
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
              <b-spinner small></b-spinner>
              Cargando...
            </span>
          </b-button>
          <b-button
            variant="outline-danger"
            :disabled="loaderAcciones"
            @click="cerrarModal()"
            >Cancelar</b-button
          >
        </template>
      </b-modal>
    </div>
  </template>
  
  <script>
  import Header from "@/components/Header";
  import {required} from "vuelidate/lib/validators";
  export default {
    name: "EstatusListadeEspera",
    components: { Header },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null,
      },
      datosTabla: [],
  
      tituloModal: "",
      show: false,
      modalAgregarEstatus: false,
      loader: false,
      fields: [
        { key: "idEstatusListaEspera", label: "ID", sortable: true },
        { key: "nombreEstatus", label: "Tipo de Solicitud", sortable: true },
        { key: "slaMinimo", label: "SLA minimo", sortable: true },
        { key: "slaMaximo", label: "SLA máximo", sortable: true },
        { key: "codigoColor", label: "Color", sortable: true },
       // { key: "proximaCita", label: "Proxima cita", sortable: true },
        {
          key: "registroActivo",
          label: "Activar / Desactivar",
        },
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 0,
      colores: [],
      tiposSolicitud: [],
      loaderAcciones: false,
      datosGuardar: {
        idEstatusListaEspera: null,
        nombreEstatus: null,
        //proximaCita: true,
        slaMinimo: null,
        slaMaximo: null,
        idColor: 0,
        //registroActivo: true,
      },
      slaInicialValidacion : false,
    }),
     validations: {
      datosGuardar: {
        nombreEstatus: {required},
        slaMinimo: {required},
        slaMaximo: {required},
        idColor: {required},
      }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();

      this.obtenerEstatus();
      this.obtenerColores();
     this.obtenerTiposSolicitud();
    },
     watch: {
     
     
     },
    methods: {
       slaKeydown(e) {
        if (/^\W$/.test(e.key)) {
          e.preventDefault();
        }
      },
      abrirModal() {
        this.tituloModal = "Agregar nuevo estatus";
        this.modalAgregarEstatus = true;
      },
      resetearDatos() {
        this.datosGuardar = {
          idEstatusListaEspera: null,
          nombreEstatus: null,
          proximaCita: true,
          slaMinimo: null,
          slaMaximo: null,
          idColor: 0,
          registroActivo: true,
        };
      },
      obtenerEstatus() {
        this.loader = true;
        this.$http
          .get(this.$api + "seguimiento/listadeespera/obtener")
          .then((respuesta) => {
            if (respuesta.data) {
              this.datosTabla = respuesta.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
      },
  
      verificarEstatus() {
        if (this.datosGuardar.slaMaximo < 0) {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Los días no pueden ser números negativos",
            });
        }else if ((Number(this.datosGuardar.slaMinimo) < Number(this.datosGuardar.slaMaximo) ) && this.datosGuardar.slaMinimo != null && this.datosGuardar.slaMaximo != null && this.datosGuardar.nombreEstatus != "") {
         this.guardarEstatus();
       }else{
        this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Verifique la información",
            });
       }
       
      },
  
      guardarEstatus(){
         this.$http.post(this.$api +"seguimiento/listadeespera/guardarnuevo",this.datosGuardar)
          .then((respuesta) => {
           
            if (respuesta) {
              
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: respuesta.data
              });
              this.resetearDatos();
              this.obtenerEstatus();
              this.modalAgregarEstatus = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrió un error",
            });
          })
          .finally(() => {
            this.loaderAcciones = false;
          });
      },
  
      modificar(item) {
        this.datosGuardar = item;
        this.tituloModal = "Modificar Estatus";
        this.modalAgregarEstatus = true;
      },
      activarDesactivarEstatus(item) {
        const mensaje = item.registroActivo
          ? "¿Está seguro de desactivar el estatus?"
          : "¿Está seguro de activar el estatus?";
        this.$swal({
          icon: "warning",
          text: mensaje,
          confirmButtonText: "Si",
          cancelButtonText: "No",
          showCancelButton: true,
          showConfirmButton: true,
        }).then((aceptar) => {
          if (aceptar.value) {
            this.$http
              .put(
                this.$api +
                  "seguimiento/listadeespera/activar-inactivar?idEstatusListaEspera=" + item.idEstatusListaEspera
              )
              .then((respuesta) => {
                if (respuesta.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de solicitud se actualizó correctamente",
                  });
                }
              });
          }
        });
      },
      obtenerColores() {
        this.$http
          .get(this.$api + "catalogos/obtener/colores")
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.colores = respuesta.data.data;
              
            }
          }); 
  
      },
  
      cerrarModal() {
        this.modalAgregarEstatus = false;
        this.resetearDatos();
      },
  
     
    },
  };
  </script>
  
  <style scoped>
  .bCardGlobal {
    margin: 2% 4% 2% 4%;
    padding: 0.5% 1% 0.5% 1%;
    border-radius: 20px;
  }
  
  .divSubtitulo {
    width: 100%;
    margin-top: 2%;
    margin-bottom: 2%;
    border-bottom: 5px solid #8ec6e9;
  }
  
  .divInput {
    margin-left: 1%;
    margin-right: 3%;
  }
  
  .textSubtitulo {
    color: #093974;
    font-weight: 600;
    font-size: 22px;
    text-align: left;
  }
  
  .overflow-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .scroll-area {
    position: relative;
    margin: auto;
    height: 500px;
  }
  </style>
  